import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { t } from "../../lib/i18n";

const RESUME_KEY = "shutterkart_draft_id";
const DISMISS_KEY = "shutterkart_draft_dismissed_at";
const DISMISS_TTL_MS = 24 * 60 * 60 * 1000;

export default function ResumeBar() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const draft = window.localStorage.getItem(RESUME_KEY);
    const dismissed = Number(window.localStorage.getItem(DISMISS_KEY) || 0);
    const dismissedFresh = dismissed && Date.now() - dismissed < DISMISS_TTL_MS;
    setShow(Boolean(draft) && !dismissedFresh);
  }, []);

  if (!show) return null;

  return (
    <div
      data-testid="resume-bar"
      className="sticky top-0 z-50 flex items-center justify-between gap-3 bg-[#1A1A1A] px-5 py-2.5 text-xs text-[#FAF7F2] sm:px-6"
    >
      <p className="truncate">
        <span className="mr-2 inline-block rounded-full bg-[#C8A24B] px-2 py-0.5 text-[10px] uppercase tracking-[0.2em] text-[#1A1A1A]">
          Draft
        </span>
        {t("resume.title")}
      </p>
      <div className="flex shrink-0 items-center gap-2">
        <Link
          to="/plan?resume=1"
          data-testid="resume-bar-cta"
          className="rounded-full bg-[#C8A24B] px-4 py-1.5 text-[11px] uppercase tracking-[0.2em] text-[#1A1A1A] transition hover:bg-[#dbb359]"
        >
          {t("resume.cta")}
        </Link>
        <button
          type="button"
          data-testid="resume-bar-dismiss"
          aria-label={t("resume.dismiss")}
          onClick={() => {
            window.localStorage.setItem(DISMISS_KEY, String(Date.now()));
            setShow(false);
          }}
          className="rounded-full p-1.5 text-[#FAF7F2]/80 transition hover:text-[#FAF7F2]"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
